import { render } from "./FileUploadList.vue?vue&type=template&id=631b37ea&scoped=true"
import script from "./FileUploadList.vue?vue&type=script&lang=js"
export * from "./FileUploadList.vue?vue&type=script&lang=js"

import "./FileUploadList.vue?vue&type=style&index=0&id=631b37ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631b37ea"]])

export default __exports__